var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStartOnline = function SvgStartOnline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2711 26.2907V34.4469C15.2711 34.7072 15.2711 34.8807 15.2711 35.141H24.5553C24.5553 34.9675 24.5553 34.7072 24.5553 34.4469V26.2907H15.2711Z",
    fill: "#03CFAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 27.2451C40 28.026 39.3926 28.7202 38.5249 28.7202H1.47505C0.694143 28.7202 0 28.1128 0 27.2451V1.47505C0 0.607375 0.607375 0 1.47505 0H38.6117C39.3926 0 40.0868 0.607375 40.0868 1.47505V27.2451H40Z",
    fill: "#03CFAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.7787V27.3319C0 28.1128 0.607375 28.8069 1.47505 28.8069H38.6117C39.3926 28.8069 40.0868 28.1996 40.0868 27.3319V21.7787H0Z",
    fill: "#007E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1887 34.7072H26.898",
    stroke: "#007E6B",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1215 12.8417C21.6052 12.8417 19.1757 12.8417 16.6594 12.8417C16.2256 11.1063 15.705 9.45771 15.2711 7.72235C18.6551 7.72235 22.1258 7.72235 25.5098 7.72235C25.0759 9.45771 24.6421 11.1931 24.1215 12.8417Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7462 12.8417L14.7505 5.72669L12.6681 5.63992",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0477 14.2299C17.5271 14.2299 17.0933 14.6638 17.0933 15.1844C17.0933 15.705 17.5271 16.1388 18.0477 16.1388C18.5683 16.1388 19.0022 15.705 19.0022 15.1844C19.0022 14.6638 18.5683 14.2299 18.0477 14.2299Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6464 14.2299C22.1258 14.2299 21.692 14.6638 21.692 15.1844C21.692 15.705 22.1258 16.1388 22.6464 16.1388C23.167 16.1388 23.6009 15.705 23.6009 15.1844C23.6009 14.6638 23.167 14.2299 22.6464 14.2299Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStartOnline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/startOnline.5768b902.svg";
export { ForwardRef as ReactComponent };